import React, { useEffect, useState } from 'react';
import { menuDTO } from './menu.model';
import axios from 'axios';
import {  webApiObtiene } from '../../routes/endpoints';
import '@szhsin/react-menu/dist/index.css';
import { Link } from 'react-router-dom';

export default function MenuSitio(){

    const [padres, setPadres] = useState<menuDTO[]>();
    useEffect(() => {  
        axios.post(webApiObtiene, {id:0}).then((response) => {
            setPadres(response.data)                       
        }).catch(err => console.warn(err)); 
    }, []);
    const agregaClass= (e:any) =>{
        let ele = document.getElementsByClassName("tituloMenu")
        for(var [key] of Object.entries(ele)) document.getElementsByClassName('tituloMenu')[parseInt(key)].classList.remove('fondoMenu');        
        e.currentTarget.classList.add('fondoMenu');        
       } 
    return(      
        <nav className="navbar navbar-expand-xl navbar-light py-0">
            <div className="container-fluid">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">   
                    { padres?.map( padre => 
                    <li className="nav-item tituloMenu" onClick={agregaClass} key={padre.id}>
                        <Link to={`${padre.urlMenuContent}`} className="mx-2 nav-link" aria-current="page">{padre.nameMenuContent}</Link>
                    </li>
                    )}
                </ul>
                </div>
            </div>
        </nav>
    )        

}